import PrivacyNotice from './PrivacyNotice';
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Stack,
  Flex,
} from '@chakra-ui/react';

import CookiesPolicy from './CookiesPolicy';
import LegalTermsHero from './LegalTermsHero';
import RiskDisclosure from './RiskDisclosure';
import { useRouter } from 'next/router';
import AmlKyc from './AmlKyc';
import TermsOfService from './TermsOfService';
import { colors } from '@/styles/theme/colors';
import { H6 } from '@/components/Headings';

export const tabs = {
  'privacy-policy': { value: 'privacy-policy', label: 'Privacy Policy' },
  'terms-conditions': {
    value: 'terms-conditions',
    label: 'Terms of Service',
  },
  'cookies-policy': { value: 'cookies-policy', label: 'Cookies Policy' },
  'risk-disclosure': { value: 'risk-disclosure', label: 'Risk Disclosure' },

  'aml-kyc': { value: 'aml-kyc', label: 'AML/KYC' },
};

const LegalTermsContainer = () => {
  const router = useRouter();

  const currentIndex = Object.entries(tabs).findIndex(
    ([_, tab]) => router.query.tab === tab.value,
  );

  return (
    <>
      <LegalTermsHero />
      <Stack w='full' pt={8} pb={4}>
        <Stack w='full'>
          <Tabs align={'center'} index={currentIndex === -1 ? 0 : currentIndex}>
            <TabList
              w={'full'}
              pb={0.5}
              px={4}
              overflowX={'auto'}
              overflowY={'hidden'}
            >
              <Flex
                mb={{ base: 0, lg: 0 }}
                w={'full'}
                maxW={'8xl'}
                justify={'start'}
              >
                {Object.entries(tabs).map(([key, tab], index) => (
                  <Tab
                    whiteSpace={'nowrap'}
                    onClick={() =>
                      router.push(`?tab=${tab.value}`, undefined, {
                        shallow: true,
                        scroll: true,
                      })
                    }
                    key={tab.value}
                    _selected={{
                      color: colors.diment.darkBlue,
                      fontWeight: 800,
                      borderBottomColor: colors.diment.lightBlue,
                    }}
                    fontWeight={500}
                    pl={key === 'privacy-policy' ? 0 : undefined}
                  >
                    <H6
                      fontWeight={currentIndex === index ? 800 : 500}
                      fontSize={{ base: 14, md: 18 }}
                      color={colors.diment.darkBlue}
                    >
                      {tab.label}
                    </H6>
                  </Tab>
                ))}
              </Flex>
            </TabList>

            <TabPanels
              bg={colors.diment.lightGrey}
              color={colors.diment.darkBlue}
              fontWeight={500}
            >
              {Object.entries(tabs).map(([key, tab], index) => (
                <TabPanel key={key} w={'full'}>
                  {key === 'privacy-policy' && <PrivacyNotice />}
                  {key === 'terms-conditions' && <TermsOfService />}
                  {key === 'cookies-policy' && <CookiesPolicy />}
                  {key === 'risk-disclosure' && <RiskDisclosure />}
                  {key === 'aml-kyc' && <AmlKyc />}
                </TabPanel>
              ))}
            </TabPanels>
          </Tabs>
        </Stack>
      </Stack>
    </>
  );
};

export default LegalTermsContainer;
